import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MarketingNav, Footer } from "@/components/MarketingNav";

export default function ComeFunziona() {
  const steps = [
    ["Tu fai la segnalazione", "Inserisci pochi dati essenziali: chi vuole vendere e dove si trova l'immobile."],
    ["Verifichiamo il contatto", "Il nostro team contatta il proprietario e verifica la reale intenzione di vendita."],
    ["Prendiamo in carico", "Se esistono le condizioni, acquisiamo l'incarico e gestiamo l'intero processo immobiliare."],
    ["Segui tutto dalla dashboard", "Ogni pratica ha un codice e una timeline: sai sempre a che punto sei."],
    ["Ricevi il tuo riconoscimento", "Quando maturano le condizioni previste, visualizzi e ricevi il tuo merito fidelizzazione."],
  ];
  return (
    <div className="min-h-screen bg-[#0A1128] text-white">
      <MarketingNav />
      <section className="pt-32 pb-16 mx-auto max-w-4xl px-5 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <p className="text-[#D4AF37] text-sm font-medium tracking-wide">COME FUNZIONA</p>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold leading-tight">
            Tu conosci le persone. Noi sappiamo vendere gli immobili.
          </h1>
          <p className="mt-6 text-white/70 leading-relaxed text-lg">
            Ogni giorno qualcuno decide di vendere casa. Potrebbe essere un amico, un collega,
            un vicino, un parente. Una persona che conosci. Tu fai semplicemente la segnalazione.
          </p>
        </motion.div>
      </section>
      <section className="pb-24 mx-auto max-w-4xl px-5 sm:px-8">
        <div className="space-y-4">
          {steps.map(([t, d], i) => (
            <motion.div key={i}
              initial={{ opacity: 0, x: -12 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="flex gap-5 rounded-xl border border-white/10 bg-white/5 p-6">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#D4AF37] text-[#0A1128] font-display font-semibold">{i + 1}</span>
              <div>
                <h3 className="font-display text-lg font-medium">{t}</h3>
                <p className="mt-1 text-white/60 leading-relaxed">{d}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <div className="mt-12 text-center">
          <Link to="/segnala" className="btn-gold inline-flex items-center gap-2 rounded-full px-8 py-4 font-semibold">
            Segnala un immobile <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
